module.exports = __webpack_public_path__ + "img/play-button.8c3f6da3.svg";